$(function (){
    $('#slider').slick({
        autoplay: true,
        speed: 2000,
        // autoplaySpeed: 4000,
        fade:true,
        arrows:false,
        pauseOnFocus: false,
		pauseOnHover: false,
    });
});

  
  